import { ModelListener } from './ModelListener';
import { FieldModel } from '../../view-model/field-model';
import { BaseModel } from '../../view-model/base-model';
import { ModelStateService } from '../view-model/model-state.service';
import { IdModel } from '../../view-model/type/id-model';

/**
 * Listener sets id in field opt-140-lot for every lot, when bt-14-lot was changed.
 * The same is applied to opt-140-part and bt-14-part.
 */
export class BT14ChangedListener extends ModelListener<FieldModel<any>> {
  constructor(private suffix: 'Part' | 'Lot') {
    super();
  }

  onChange(model: FieldModel<any>) {
    const bt14Models = ModelStateService.findModelsById(model.root, `BT-14-${this.suffix}`);
    let initialOptId = 1;

    bt14Models.forEach((model: FieldModel<string>) => {
      if (model?.value) {
        const opt140Model: IdModel = ModelStateService.findModelById(
          model.parent,
          `OPT-140-${this.suffix}`
        );
        opt140Model.value = `-${initialOptId}`;
        initialOptId++;
        opt140Model.emitChange();
      }
    });
  }

  shouldAttach(model: BaseModel): boolean {
    return model.noticeNode?.id === `BT-14-${this.suffix}`;
  }
}
